import {
  AlertCircleIcon,
  Alert01Icon,
  Tick01Icon,
  CancelCircleIcon,
} from '@terra/ui-icons';
import { Badge } from '../../components/badge';

type McpServerStatus = {
  enabled: boolean;
  consecutiveFailures: number;
  lastHealthCheck?: string | Date | null;
};
type McpServerStatusBadgeProps = {
  server: McpServerStatus;
  statusDisabled: string;
  statusFailing: string;
  statusDegraded: string;
  statusConnected: string;
  statusNotTested: string;
};

export function McpServerStatusBadge({
  server,
  statusDisabled,
  statusFailing,
  statusDegraded,
  statusConnected,
  statusNotTested,
}: McpServerStatusBadgeProps) {
  if (!server.enabled) {
    return (
      <Badge
        variant="outline"
        colorScheme="gray"
        icon={<AlertCircleIcon size={11} />}
      >
        {statusDisabled}
      </Badge>
    );
  }

  if (server.consecutiveFailures >= 3) {
    return (
      <Badge
        variant="outline"
        colorScheme="red"
        icon={<CancelCircleIcon size={11} />}
      >
        {statusFailing}
      </Badge>
    );
  }

  if (server.consecutiveFailures > 0) {
    return (
      <Badge
        variant="outline"
        colorScheme="orange"
        icon={<Alert01Icon size={11} />}
      >
        {statusDegraded}
      </Badge>
    );
  }

  if (server.lastHealthCheck) {
    return (
      <Badge
        variant="outline"
        size="sm"
        colorScheme="green"
        icon={<Tick01Icon size={10} />}
      >
        {statusConnected}
      </Badge>
    );
  }

  return <Badge variant="fill">{statusNotTested}</Badge>;
}
